import { UpdateCigBoxNoteNew } from "../../data-model/updateCigBoxNoteNew";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const updateCigBoxNote = async (body: {
  patient_mrn: string;
  drug_name: string;
  note: string;
  identifier: string;
  visit_date?: string;
}) => {
  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.UPDATE_CIG_BOX_DATA, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to update CIG box note:", error);
    throw error;
  }
};

export const updateCigBoxNoteNewEndpoint = async (
  body: UpdateCigBoxNoteNew,
) => {
  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.UPDATE_CIG_BOX_DATA, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to update CIG box note:", error);
    throw error;
  }
};
